import { getApiErrorMessage } from "utils/http/apiError";

type CasesServiceError = string | { detail?: string[] } | unknown;

type CasesServiceResponse = {
  success?: boolean;
  errors?: CasesServiceError;
  message?: string;
  data?: { cases?: unknown[]; pagination?: unknown };
};

type CasesListParseResult = {
  cases: unknown[];
  pagination: Record<string, unknown>;
};

export function parseCasesListResponse(res: CasesServiceResponse): CasesListParseResult | null {
  if (res.success === true && res.data?.cases) {
    const pagination =
      (res.data.pagination as Record<string, unknown> | undefined) ??
      ({ total_cases: res.data.cases.length } as Record<string, unknown>);
    return { cases: res.data.cases, pagination };
  }
  return null;
}

type SearchCasesServiceResponse = CasesServiceResponse & {
  data?: {
    search_results?: { cases?: unknown[] };
    pagination?: Record<string, unknown>;
  };
};

export function parseSearchCasesResponse(
  res: SearchCasesServiceResponse
): CasesListParseResult | null {
  if (res.success !== true) return null;

  const data = res.data;
  const cases = data?.search_results?.cases;

  if (Array.isArray(cases)) {
    const pagination = (data?.pagination as Record<string, unknown> | undefined) ?? {
      total_cases: cases.length,
    };
    return { cases, pagination };
  }

  // API may return success with empty data (e.g. data: {}) when no cases match.
  return {
    cases: [],
    pagination: (data?.pagination as Record<string, unknown> | undefined) ?? { total_cases: 0 },
  };
}

export const parseClientCasesResponse = parseCasesListResponse;

export function getCasesFetchErrorMessage(
  res: CasesServiceResponse,
  fallback = "Failed to fetch cases"
): string {
  return getApiErrorMessage(res.errors ?? res.message, fallback);
}
